import { defineComponent as _defineComponent } from 'vue';
import { getCurrentInstance } from 'vue';
import { ReviewType } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'ReviewTypeLabel',
  props: {
    reviewType: {
      default: ReviewType.TheoryOfChange
    },
    heading: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _ref = getCurrentInstance(),
      proxy = _ref.proxy;
    var label = computed(function () {
      var _props$reviewType;
      var key = (_props$reviewType = props.reviewType) !== null && _props$reviewType !== void 0 ? _props$reviewType : ReviewType.TheoryOfChange;
      return String(proxy.$t(key));
    });
    var rootClass = computed(function () {
      return props.heading ? 'text-h5 font-weight-bold mb-0 primary--text' : 'text-body-2 font-weight-medium';
    });
    return {
      __sfc: true,
      props: props,
      proxy: proxy,
      label: label,
      rootClass: rootClass
    };
  }
});